Ext.define('SA.ActiveState', {
    statics: {
        createInactive() {
            return new SA.ActiveState({active: false});
        }
    },

    constructor({active = true} = {}) {
        this.active = active;
        this.everActive = active;

        this.observable = new Ext.util.Observable();
    },

    activate() {
        this.setActive(true);
    },

    deactivate() {
        this.setActive(false);
    },

    isActive() {
        return this.active;
    },

    onActive(callback, scope) {
        this.observable.on('active', callback, scope);
    },

    onChange(callback, scope) {
        this.observable.on('change', callback, scope);
    },

    onFirstActive(callback, scope) {
        this.observable.on('firstActive', callback, scope);
    },

    onInactive(callback, scope) {
        this.observable.on('inactive', callback, scope);
    },

    setActive(active) {
        this.active = active;

        if (active && !this.everActive) {
            this.everActive = true;
            this.observable.fireEvent('firstActive');
        }

        this.observable.fireEvent(active ? 'active' : 'inactive');
        this.observable.fireEvent('change', active);
    }
});